import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import ListViewCpt from '@/components/list/ListViewCpt';
import cptCmn from '@/mixin/cpt-cmn';
import { rqtPostListAppointmentQueuePage } from '@/services/wms/appointment';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    ListViewCpt
  },
  data() {
    return {
      listRequest: rqtPostListAppointmentQueuePage,
      codeResItems: [{
        title: '排队状态',
        dataIndex: 'queueStatus',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'queueStatus'
      }]
    };
  },
  mounted() {
    this.initResCodeType(this.codeResItems);
  },
  methods: {
    getStatusStyle(status) {
      let color = undefined;
      switch (status) {
        case '01':
          color = '#1989fa';
          break;
        case '02':
          color = '#07c160';
          break;
        case '03':
          color = '#ee0a24';
          break;
      }
      return color;
    }
  }
};